import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserLandingsV2Component } from './user-landings-v2.component';
import { TranslateModule } from '@ngx-translate/core';
import { EvaButtonModule } from '../eva-button/eva-button.module';
import { EvaMessageModule } from '../eva-message/eva-message.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserLandingsCardV2Component } from './user-landings-card-v2/user-landings-card-v2.component';
import { DropdownService } from './dropdown.service';
import { UserLandingsContentModalComponent } from './user-landings-content-modal/user-landings-content-modal.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    UserLandingsV2Component,
    UserLandingsCardV2Component,
    UserLandingsContentModalComponent
  ],
  providers: [
    DropdownService
  ],
  imports: [
    CommonModule,
    TranslateModule,
    EvaButtonModule,
    EvaMessageModule,
    BrowserAnimationsModule,
    FormsModule
  ],
  exports: [
    UserLandingsV2Component,
    UserLandingsCardV2Component,
  ]
})
export class UserLandingsV2Module { }
